import { type IncomingRequest } from '@/services/api/teacher'

export interface RequestBadgesProps {
  request: Pick<IncomingRequest, 'is_in_panic_zone' | 'is_urgent' | 'is_nothilfe'>
}

// Konzept A: Prep-Status wohnt im Prep-Band der Karte (angefragt / X/Y Prep /
// Kein Prep) — hier bleiben nur die Dringlichkeits-Badges.
export function RequestBadges({ request }: RequestBadgesProps) {
  return (
    <>
      {request.is_in_panic_zone && (
        <span className="px-1.5 py-0.5 text-xs rounded bg-red-500 text-white font-medium shrink-0">
          DRINGEND
        </span>
      )}
      {request.is_urgent && (
        <span className="px-1.5 py-0.5 text-xs rounded bg-orange-500 text-white font-medium shrink-0">
          EILIG
        </span>
      )}
      {request.is_nothilfe && (
        <span
          className="px-1.5 py-0.5 text-xs rounded bg-orange-100 text-orange-800 dark:bg-orange-900/40 dark:text-orange-200 font-medium shrink-0"
          title="Unqualifiziert an einem Panik-Tag (Nothilfe)"
        >
          Nothilfe
        </span>
      )}
    </>
  )
}
